import { WebSocketTrace, wrapRTCPeerConnection } from '@rtcstats/rtcstats-js';
import { logger } from 'utils/logger';
import { RtcStatsServer } from 'features/room/types';
import { StatsTrace } from 'utils/webrtc/stats/rtcstats-trace';

// Dev-only fallback sink; production uses the per-session rtcStatsServer from the room-join payload.
export const RTCSTATS_WS_URL = process.env.REACT_APP_RTCSTATS_WS_URL;

let statsTrace: StatsTrace | undefined;

export const installRtcStats = (rtcStatsServer?: RtcStatsServer): StatsTrace | undefined => {
  if (statsTrace) {
    return statsTrace;
  }

  if (!rtcStatsServer && !RTCSTATS_WS_URL) {
    return undefined;
  }

  try {
    const rawTrace = WebSocketTrace({});
    statsTrace = new StatsTrace({
      rawTrace,
      isEmissionEnabled: () => true,
    });
    wrapRTCPeerConnection(statsTrace.trace, window, { getStatsInterval: 0 });
  } catch (error) {
    logger.remote({ system: true }).warn('Failed to install rtcstats', error);
  }

  return statsTrace;
};

export const getStatsTrace = (): StatsTrace | undefined => statsTrace;
